import emailjs from '@emailjs/browser'

interface ErrorEmailParams {
  time: string
  endpoint: string
  status: number
  response: string
  errorType: string
  errorMessage: string
  requestId: string
}

export const sendErrorEmail = async (
  params: ErrorEmailParams,
): Promise<void> => {
  try {
    await emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '',
      {
        time: params.time,
        endpoint: params.endpoint,
        status: params.status,
        response: params.response,
        errorType: params.errorType,
        errorMessage: params.errorMessage,
        requestId: params.requestId,
      },
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '',
    )
  } catch (error) {
    console.error('Failed to send error email:', error)
  }
}
